module.exports = __webpack_public_path__ + "img/h6.e19d8e7c.jpg";